import React from "react";

const ICONS = {
    note:    "📝",
    call:    "📞",
    email:   "✉️",
    meeting: "🤝",
    task:    "✅",
};

const ActivityIcon = ({ type }) => (
    <div className={`crm-activity-icon crm-activity-icon--${type}`}>
        {ICONS[type] || "📋"}
    </div>
);

export default ActivityIcon;
